import { inject, Injectable } from '@angular/core';

import { select, Store } from '@ngrx/store';
import { Observable, shareReplay } from 'rxjs';
import { Memoize } from 'typescript-memoize';

import { filterBoolean } from '@core/common-legacy';
import { ReportsMetricsSelectors } from '@core/reports-data';
import { ReportDashboardMetricOptions } from '@core/reports-types';

@Injectable({
  providedIn: 'root',
})
export class ReportsConfigurationFacade {
  private readonly store = inject(Store);

  public metrics$ = this.store.pipe(
    select(ReportsMetricsSelectors.allEntities),
    filterBoolean,
    shareReplay(1),
  );

  @Memoize()
  public getMetricBySlug(metricSlug: string): Observable<ReportDashboardMetricOptions> {
    return this.store.pipe(
      select(ReportsMetricsSelectors.byId(metricSlug)),
      filterBoolean,
      shareReplay(1),
    );
  }
}
